export default {_name:'button.inverted',module:'Field',view:'Element/Button',options:{variant:'contained',color:'transparent',xs:'auto',ms:'auto'}}